<template>
  <div class="m-content">
    <div class="main-content">
      <img class="back-image":src="backGround" />
      <span v-for="(pep,index) in showArray" :class="['anchor'+index,pep==3?'arrived':'']" @click="openAnimal(index)">
        <span  v-if="pep==2&&index<=14" class="tip-text">{{index==0?'开始':'继续'}}</span>
        <span v-if="pep==2&&index>14" class="icon-box"><i class="iconfont icon-flag" title="终点"></i></span>
      </span>
      <div>
        <div class="mask" @click="closeAnimal" v-if="show"></div>
        <ul class="topic-box">
          <AnimalLi v-for = "(pep,index) in arr" :content="pep" :key="index" v-on:listenToChildEvent="showNext"></AnimalLi>
        </ul>
        <div class="topic-box" v-if="show&&current>14">
          <p>你的代表动物是{{animal}}</p>
          <img class="type-img" :src="animalType" />
          <button class="default-btn medium-btn submit-btn" @click="toReport">查看你的性格报告类型</button>
          <p>恭喜你，第2关已解锁</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import qs from 'qs';
import store from '../store/index'
import setWechatTitle from '@/utils/setWechatTitle.js'
import AnimalLi from '../components/AnimalLi';
export default {
  props: {
    id: Number
  },
  name: 'AnimalTown',
  components:{
    'AnimalLi':AnimalLi
  },
  data () {
    return {
        arr:[
            {'num':1,'order':'1/4','title':'你认为自己是个____？','A':'S：务实且有丰富常识的人','B':'N：头脑灵活的人','Anext':3,'Bnext':2,'show':false},
            {'num':2,'order':'2/4','title':'你认为自己____？','A':'F：人际和谐','B':'T：思想严谨','Anext':4,'Bnext':5,'show':false},
            {'num':3,'order':'2/4','title':'以下哪个词更能描述你？','A':'J：有计划','B':'P：有弹性','Anext':6,'Bnext':7,'show':false},
            {'num':4,'order':'3/4','title':'你认为自己：','A':'E：活泼','B':'I：沉静','Anext':10,'Bnext':11,'show':false},
            {'num':5,'order':'3/4','title':'按计划日程表办事?','A':'J：正合你意','B':'P：束缚了你','Anext':8,'Bnext':9,'show':false},
            {'num':6,'order':'3/4','title':'更容易受到什么支配?','A':'F：你的体验','B':'T：你的思想','Anext':13,'Bnext':12,'show':false},
            {'num':7,'order':'3/4','title':'你通常____?','A':'I：不太把自己的事情告诉别人','B':'E：非常坦率','Anext':15,'Bnext':14,'show':false},
            {'num':8,'order':'4/4','title':'你认为自己:','A':'I：善于倾听','B':'E：善于表达','Anext':'INTJ','Bnext':'ENTJ','show':false},
            {'num':9,'order':'4/4','title':'当和一群人在一起时，你会?','A':'E：参加大家的谈话','B':'I：只同熟知的人单独谈话','Anext':'ENTP','Bnext':'INTP','show':false},
            {'num':10,'order':'4/4','title':'你认为自己:','A':'J：时间观念强','B':'P：善随机应变','Anext':'ENFJ','Bnext':'ENFP','show':false},
            {'num':11,'order':'4/4','title':'你做事更倾向于:','A':'J：果断','B':'P：灵活','Anext':'INFJ','Bnext':'INFP','show':false},
            {'num':12,'order':'4/4','title':'与陌生人交流:','A':'I：不要那么人来疯','B':'E：更加轻松和享受','Anext':'ISTJ','Bnext':'ESTJ','show':false},
            {'num':13,'order':'4/4','title':'你认为自己____?','A':'E：即刻出击','B':'I：文火慢热','Anext':'ESFJ','Bnext':'ISFJ','show':false},
            {'num':14,'order':'4/4','title':'哪种说法你更认可:','A':'T：情有可原但法不如恕','B':'F：法不如恕但情有可原','Anext':'ESTP','Bnext':'ESFP','show':false},
            {'num':15,'order':'4/4','title':'你认为自己被称为____是更高的赞赏?','A':'F：感性的人','B':'T：一贯理性的人','Anext':'ISFP','Bnext':'ISTP','show':false},
          ],
        arrAnimal:[{'type':'ENTJ','animal':'狮子','path':[1,4,7,25]},
                  {'type':'INTJ','animal':'老虎','path':[1,4,7,26]},
                  {'type':'ENTP','animal':'鹦鹉','path':[1,4,8,23]},
                  {'type':'INTP','animal':'猫头鹰','path':[1,4,8,24]},
                  {'type':'ENFJ','animal':'狗','path':[1,3,9,27]},
                  {'type':'INFJ','animal':'熊猫','path':[1,3,10,29]},
                  {'type':'ENFP','animal':'大猩猩','path':[1,3,9,28]},
                  {'type':'INFP','animal':'海豹','path':[1,3,10,30]},
                  {'type':'ESTP','animal':'鬛狗','path':[2,6,13,17]},
                  {'type':'ISTP','animal':'蛇','path':[2,6,14,15]},
                  {'type':'ESFP','animal':'海豚','path':[2,6,13,18]},
                  {'type':'ISFP','animal':'猫','path':[2,6,14,16]},
                  {'type':'ESTJ','animal':'狼','path':[2,5,11,20]},
                  {'type':'ISTJ','animal':'乌龟','path':[2,5,11,19]},
                  {'type':'ESFJ','animal':'大象','path':[2,5,12,22]},
                  {'type':'ISFJ','animal':'犀牛','path':[2,5,12,21]}
                  ],
        showArray:[2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
        current:0,
        animal:'',
        animalType:'',
        cosAnswer:'',
        show:false,
        backGround:'http://sys.rennengda.com/public/images/animalTown/animal.jpg',
        submitNum:0
    }
  },
  computed:{
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    })
  },
  created(){
    setWechatTitle('生涯驿站-疯狂动物城')
    this.setAnimalPath()
  },
  mounted() {
    setInterval(this.setTimes, 1000);
  },
  methods:{
    // 设置轨迹
    setAnimalPath(){
      let path = []
      if(this.shengyaUser.cosAnimal){
        this.arrAnimal.some((item,index)=>{
          if(item.type==this.shengyaUser.cosAnimal){
            this.animalType = 'http://sys.rennengda.com/public/images/animalTown/'+this.shengyaUser.cosAnimal+'.png'
            this.animal = item.animal
            path = item.path
          }
        })
      }
      if(path.length>0){
        path.splice(0,0,0)
        path.map((item,index)=>{
          if(item>14){
            this.current = item
            this.$set(this.showArray,item,2)
          }else{
            this.$set(this.showArray,item,3)
          }
        })
      }
    },
    // 设置当前点闪现
    setTimes(){
      let n = this.current
      if(this.show){
        this.$set(this.showArray,n,1)
      }else{
        if(this.showArray[n]==2){
          this.$set(this.showArray,n,1)
        }else{
          this.$set(this.showArray,n,2)
        }
      }
    },
    // 点击打开题本
    openAnimal(m){
      let n = this.current
      if(m==n&&this.showArray[n]){
        this.show = true
        if(n<15){
          this.arr[n].show = true
        }else{

        }
      }
    },
    closeAnimal(){
      let n = this.current
      this.show = false
      if(n<15){
        this.arr[n].show = false
      }else{

      }
    },
  showNext(result){
    this.arr.map ((item)=>{ //map改成some，符合条件执行操作后，就可以退出循环，否则会全部循环一遍
      if(item.show){
        item.show=false;
        this.$set(this.showArray,this.current,3)
      }
    })
    this.show = false
    if(typeof(result)=="number"){
      this.arr.map ((item)=>{
        if(item.num==result){
          this.current = item.num-1
          this.$set(this.showArray,this.current,1)
        }
      })
    }else{
      if(this.submitNum==0){
        this.submitNum=1
        this.setCurrent(result)  // 设置当前MBTI类型
        this.show = true
          this.animalType = 'http://sys.rennengda.com/public/images/animalTown/'+result+'.png'
          this.$set(this.showArray,this.current,1)
          const options = {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded'},
            data:qs.stringify({
              submitdata: result,
              openId: this.shengyaUser.openid
            }),
            url:'/cob/saveCosAnimalAnswer.do'
          };
          axios(options)
          .then((response)=>{
            if(response.data.result.success){
              this.cosAnswer = response.data
              this.arrAnimal.some((item,index)=>{
                if(item.type==result){
                  this.animal = item.animal
                }
              })
            }
          })
          .catch((error)=>{
            console.log(error);
          })

          return true
        }
      }
    },
    setCurrent(result){
      if(result=='ISTP'){
        this.current = 15
      }else if(result=='ISFP'){
        this.current = 16
      }else if(result=='ESTP'){
        this.current = 17
      }else if(result=='ESFP'){
        this.current = 18
      }else if(result=='ISTJ'){
        this.current = 19
      }else if(result=='ESTJ'){
        this.current = 20
      }else if(result=='ISFJ'){
        this.current = 21
      }else if(result=='ESFJ'){
        this.current = 22
      }else if(result=='ENTP'){
        this.current = 23
      }else if(result=='INTP'){
        this.current = 24
      }else if(result=='ENTJ'){
        this.current = 25
      }else if(result=='INTJ'){
        this.current = 26
      }else if(result=='ENFJ'){
        this.current = 27
      }else if(result=='ENFP'){
        this.current = 28
      }else if(result=='INFJ'){
        this.current = 29
      }else if(result=='INFP'){
        this.current = 30
      }
    },
    toReport(){
      if(this.cosAnswer){
        let shengyaUser = this.cosAnswer.data.user
        this.$bus.$emit('play-finish', shengyaUser)
      }else{
        this.$bus.$emit('play-finish', this.shengyaUser)
      }
    }
  }
}
</script>

<style scoped lang="stylus" >
.m-content
  width:100%
  overflow:auto
  .main-content
    position:relative
    margin:auto
    width:7.1rem
    height:14.2rem
    padding:0.3rem 0rem
    .mask
      height: 100%
      width: 100%
      position: fixed
      top: 0
    .back-image
      width:7.1rem
    .arrived
      width:0.6rem
      height:0.6rem
      background-color:#C31216
    span
      position:absolute
      width:0.6rem
      height:0.6rem
      border-radius:50%
      background-color:#ffffff
      .icon-box
        width:0.8rem
        height:0.8rem
        position: absolute
        left:-0.1rem
        top: 0
        text-align: center
        line-height: 0.8rem
        background-color :#C31216
        i
          color: #ffffff
          font-size: 0.4rem
      .head-img
        width:0.7rem
        height:0.7rem
        border-radius:50%
        border:2px #FFDE00 solid
        position:absolute
        top:0
        left:-0.1rem
      .tip-text
        width:0.8rem
        height:0.8rem
        line-height:0.8rem
        text-align:center
        background-color:#C31216
        color:#ffffff
        position:absolute
        top:0
        left:-0.1rem
    .anchor0
      bottom:0.45rem
      left:50%
      margin-left:-0.42rem
    .anchor2
      bottom:0
      margin-bottom:2.5rem
      left:50%
      margin-left:-0rem
    .anchor1
      bottom:4.05rem
      left:50%
      margin-left:-1.35rem
    .anchor6
      bottom:4.9rem
      left:50%
      margin-left:0.4rem
    .anchor5
      bottom:7.35rem
      left:50%
      margin-left:-0.22rem
    .anchor4
      bottom:8.3rem
      left:50%
      margin-left:-0.7rem
    .anchor3
      bottom:6.3rem
      left:50%
      margin-left:-1.85rem
    .anchor14
      bottom:2.5rem
      left:50%
      margin-left:1.65rem
    .anchor13
      bottom:4.05rem
      left:50%
      margin-left:2.75rem
    .anchor11
      bottom:8.92rem
      left:50%
      margin-left:1.22rem
    .anchor12
      bottom:11.25rem
      left:50%
      margin-left:1.32rem
    .anchor8
      bottom:10.4rem
      left:50%
      margin-left:0.2rem
    .anchor7
      bottom:11.22rem
      left:50%
      margin-left:-0.72rem
     .anchor9
      bottom:10.22rem
      left:50%
      margin-left:-3.05rem
    .anchor10
      bottom:5.1rem
      left:50%
      margin-left:-2.9rem
    .anchor15
      bottom:1.45rem
      left:50%
      margin-left:1rem
    .anchor16
      bottom:1.2rem
      left:50%
      margin-left:2.4rem
    .anchor17
      bottom:3.85rem
      left:50%
      margin-left:1.55rem
    .anchor18
      bottom:5.2rem
      left:50%
      margin-left:2.15rem
    .anchor19
      bottom:6.92rem
      left:50%
      margin-left:0.9rem
    .anchor20
      bottom:7.6rem
      left:50%
      margin-left:2.78rem
    .anchor21
      bottom:9.92rem
      left:50%
      margin-left:1.92rem
    .anchor22
      bottom:11.55rem
      left:50%
      margin-left:2.47rem
    .anchor23
      bottom:12.6rem
      left:50%
      margin-left:1.95rem
    .anchor24
      bottom:12.6rem
      left:50%
      margin-left:0.4rem
    .anchor25
      bottom:13.15rem
      left:50%
      margin-left:-0.4rem
    .anchor26
      bottom:12.62rem
      left:50%
      margin-left:-3.02rem
    .anchor27
      bottom:11.52rem
      left:50%
      margin-left:-3.45rem
    .anchor28
      bottom:8.25rem
      left:50%
      margin-left:-2.55rem
    .anchor29
      bottom:4.35rem
      left:50%
      margin-left:-3.55rem
    .anchor30
      bottom:2.54rem
      left:50%
      margin-left:-1.9rem
    .topic-box
      position:fixed
      width:70%
      top:15%
      left:15%
      background-color:rgba(0,0,0,0.6)
      z-index:10
      p
        color:#ffffff
        text-align:center
        margin:1rem auto 0.5rem auto
        font-size:0.32rem
      .submit-btn
        margin-bottom:0.5rem
      .type-img
        display:block
        margin:auto
        width:60%
</style>
